import "../0.styles.css";
import { MaterialReactTable } from "material-react-table";
import { Box, Button, Container, Grid, IconButton, TextField, Dialog, DialogTitle, DialogContent, DialogActions } from "@mui/material";
import AddCircleTwoToneIcon from "@mui/icons-material/AddCircleTwoTone";
import EditTwoToneIcon from "@mui/icons-material/EditTwoTone";
import { MRT_Localization_ES } from "material-react-table/locales/es";
import { deleteTableDots, functions, instance, validateFunction } from "../Components/config";
import { useAuth } from "../Components/AuthContext";
import { DialogAlert } from "../Components/DialogAlert";
import { DropDownList } from "../Components/DropDownList";
import { useMemo, useState } from "react";
import { LoaderBox } from "../Components/LoaderBox";

function Localidades() {
  const { user } = useAuth();
  const [items, setItems] = useState([]);
  const [isLoading, setLoading] = useState(true);
  const [openForm, setOpenForm] = useState(false);
  const [editId, setEditId] = useState(null);
  const [nombre, setNombre] = useState("");
  const [direccion, setDireccion] = useState("");
  const [centroRegional, setCentroRegional] = useState("");
  const [subcentro, setSubcentro] = useState("");
  const [departamento, setDepartamento] = useState({ Id: "", Nombre: "" });
  const [municipio, setMunicipio] = useState({ Id: "", Nombre: "" });

  const [openDialog, setOpenDialog] = useState(false);
  const [dialog, setDialog] = useState({ title: "", text: "" });

  deleteTableDots(2);

  const columns = useMemo(() => [
    { accessorKey: "Id", header: "ID" },
    { accessorKey: "Nombre", header: "Nombre" },
    { accessorKey: "departamento", header: "Departamento" },
    { accessorKey: "municipio", header: "Municipio" },
    { accessorKey: "centroRegional", header: "Centro regional" },
    { accessorKey: "subcentro", header: "Subcentro" },
    {
      accessorFn: () => "edit",
      id: "edit",
      header: "",
      size: 50,
      enableColumnFilter: false,
      Cell: ({ row }) => validateFunction(user, functions.ModifyLocalidad) && (
        <Button onClick={() => handleEditar(row.original)}>
          <EditTwoToneIcon /> Editar
        </Button>
      ),
    },
  ], []);

  function populateTable() {
    instance.get("/localidad/listCompleto")
      .then((res) => setItems(res.data))
      .catch((err) => {
        setDialog({
          title: "ERROR",
          text: err.response?.status === 500
            ? "Existe algún problema con el servidor, por favor inténtalo de nuevo mas tarde."
            : err.response?.data?.message || "Error desconocido"
        });
        setOpenDialog(true);
      });
  }

  if (isLoading) {
    populateTable();
    setLoading(false);
  }

  const handleEditar = (row) => {
    setEditId(row.Id);
    setNombre(row.Nombre);
    setDireccion(row.Direccion || "");
    setCentroRegional(row.centroRegional || "");
    setSubcentro(row.subcentro || "");
    setDepartamento({ Id: row.idDepartamento, Nombre: row.departamento });
    setMunicipio({ Id: row.idMunicipio, Nombre: row.municipio });
    setOpenForm(true);
  };

  const handleGuardar = () => {
    if (!nombre || !direccion || departamento.Id === "" || municipio.Id === "") {
      setDialog({ title: "Aviso", text: "Debe ingresar el nombre, dirección, departamento y municipio." });
      setOpenDialog(true);
      return;
    }
    const payload = {
      nombre,
      direccion: direccion || null,
      idMunicipio: municipio.Id,
      centroRegional: centroRegional || null,
      subcentro: subcentro || null
    };

    const request = editId
      ? instance.put("/localidad/actualizar", { id: editId, ...payload })
      : instance.post("/localidad/crear", payload);

    request
      .then(() => {
        setDialog({ title: "Aviso", text: editId ? "Localidad actualizada exitosamente." : "Localidad creada exitosamente." });
        setOpenDialog(true);
        limpiarForm();
        setOpenForm(false);
        populateTable();
      })
      .catch((err) => {
        setDialog({
          title: "ERROR",
          text: err.response?.status === 500
            ? "Existe algún problema con el servidor."
            : err.response?.data?.message || "Error desconocido"
        });
        setOpenDialog(true);
      });
  };

  const limpiarForm = () => {
    setEditId(null);
    setNombre("");
    setDireccion("");
    setCentroRegional("");
    setSubcentro("");
    setDepartamento({ Id: "", Nombre: "" });
    setMunicipio({ Id: "", Nombre: "" });
  };

  return (
    <LoaderBox isLoading={isLoading}>
      <Container maxWidth="xl" sx={{ marginTop: 2 }}>
        <Box sx={{ display: "flex", flexDirection: "column", alignItems: "center", marginBottom: 4 }}>
          <Grid container gap={{ xs: "0px", sm: "12px" }}>
            <Grid item xs={12}>
              <MaterialReactTable
                localization={MRT_Localization_ES}
                columns={columns}
                data={items}
                enableColumnFilterModes={false}
                enableColumnOrdering={false}
                enableGrouping={false}
                enablePinning={false}
                enableRowActions={false}
                initialState={{
                  pagination: { pageSize: 10 },
                  showColumnFilters: false,
                  columnVisibility: { Id: false, edit: validateFunction(user, functions.ModifyLocalidad) },
                }}
                positionToolbarAlertBanner="none"
                enableColumnFilters={false}
                enableGlobalFilter={true}
                enableDensityToggle={false}
                enableFullScreenToggle={false}
                enableHiding={false}
                enablePagination={true}
                enableTopToolbar={true}
                enableBottomToolbar={true}
                renderTopToolbarCustomActions={() => (
                  validateFunction(user, functions.CreateLocalidad) && (
                  <IconButton color="success" onClick={() => setOpenForm(true)} variant="contained">
                    <AddCircleTwoToneIcon />
                    <p className="IconButtonText">Agregar</p>
                  </IconButton>
                  )
                )}
              />
            </Grid>
          </Grid>
        </Box>
      </Container>

      <Dialog open={openForm} onClose={() => setOpenForm(false)} maxWidth="sm" fullWidth>
        <DialogTitle>{editId ? "Editar localidad" : "Nueva localidad / centro de costo"}</DialogTitle>
        <DialogContent dividers>
          <Grid container spacing={2} sx={{ mt: 0.5 }}>
            <Grid item xs={12}>
              <TextField required fullWidth label="Nombre" value={nombre} onChange={(e) => setNombre(e.target.value)} />
            </Grid>
            <Grid item xs={12}>
              <TextField required fullWidth label="Dirección" value={direccion} onChange={(e) => setDireccion(e.target.value)} />
            </Grid>
            <Grid item xs={12} sm={6}>
              <p>Departamento</p>
              <DropDownList
                required
                menuPortal
                title="Departamento"
                endpoint="/localidad/listActiveDepartamento/"
                selectedItem={departamento}
                setSelectedItem={setDepartamento}
              />
            </Grid>
            <Grid item xs={12} sm={6}>
              <p>Municipio</p>
              <DropDownList
                required
                menuPortal
                title="Municipio"
                endpoint={departamento.Id !== "" ? `/localidad/listActiveMunicipio/${departamento.Id}` : undefined}
                selectedItem={municipio}
                setSelectedItem={setMunicipio}
                disabled={departamento.Id === ""}
                hierarchyUpdated={departamento}
              />
            </Grid>
            <Grid item xs={12} sm={6}>
              <TextField fullWidth label="Centro regional" value={centroRegional} onChange={(e) => setCentroRegional(e.target.value)} />
            </Grid>
            <Grid item xs={12} sm={6}>
              <TextField fullWidth label="Subcentro" value={subcentro} onChange={(e) => setSubcentro(e.target.value)} />
            </Grid>
          </Grid>
        </DialogContent>
        <DialogActions>
          <Button onClick={() => { limpiarForm(); setOpenForm(false); }}>Cancelar</Button>
          <Button variant="contained" onClick={handleGuardar}>{editId ? "Actualizar" : "Crear"}</Button>
        </DialogActions>
      </Dialog>

      <DialogAlert
        title={dialog.title}
        text={dialog.text}
        open={openDialog}
        setOpen={setOpenDialog}
      />
    </LoaderBox>
  );
}

export { Localidades };
